import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useDate } from "@/hooks/use-date/useDate";
import { Icon } from "@/components/icons/Icon";
import { PHASES_LIST } from "@/assets/constants/selectsLists";

import type { FC } from "react";

interface CurrentPhaseDescktopProps {
  currentPhase: number | null;
  tasks: number;
  completed: number;
  phaseStartDate: string;
}

const CurrentPhaseDescktop: FC<CurrentPhaseDescktopProps> = ({
  currentPhase,
  tasks,
  completed,
  phaseStartDate,
}) => {
  const translate = useTranslate();
  const { formatDate, getDaysSince } = useDate();

  const getPhaseName = () => {
    return PHASES_LIST.find((item) => item.id === currentPhase)?.name || "";
  };

  const processStatus = {
    width: `${tasks && completed ? (230 / tasks) * completed : 0}px`,
  };

  return (
    <div className="w-full border-b border-b-ib-gray-lightest bg-ib-gray-lightest-2 flex flex-row items-center py-1 px-14 justify-between">
      <div className="text-ib-main flex flex-row items-center gap-x-6">
        <div className="text-ib-main flex flex-row items-center">
          <Icon name="gear" className="size-4 text-ib-gray-dark-2 mr-1" />
          <div className="text-ib-gray-main mr-1">
            {translate("inProgress")}:
          </div>
          <div className="ib-gray-darkest font-ib-bold">
            {translate(getPhaseName())}
          </div>
        </div>
        <div className="hidden lg:flex w-[230px] h-2 rounded-md bg-ib-gray-borders">
          <div
            data-testid="progressbar"
            style={processStatus}
            className={`h-2 rounded-md bg-ib-blue-progress`}
          ></div>
        </div>
        <div className="text-ib-main flex flex-row items-center">
          <div className="text-ib-gray-main mr-1">
            {translate("completed")}:
          </div>
          <div className="ib-gray-darkest font-ib-bold">
            {translate("tasksCompleted", [
              completed.toString(),
              tasks.toString(),
            ])}
          </div>
        </div>
      </div>
      <div className="h-7 flex flex-row gap-x-2 bg-ib-gray-lightest rounded-lg items-center px-4 min-w-[209px] justify-between">
        <div className="text-ib-main">
          <span className="text-ib-gray-main mr-0.5">
            {translate("stageStart")}:
          </span>
          <span className="text-ib-gray-darkest">
            {formatDate(phaseStartDate)}
          </span>
        </div>
        <div className="text-ib-main text-ib-gray-darkest font-ib-bold">
          {getDaysSince(phaseStartDate)}
        </div>
      </div>
    </div>
  );
};

export default CurrentPhaseDescktop;
